import { EVENT } from "../config";
import { Ship, Waves, Wine, UtensilsCrossed, PartyPopper, Clock, Music } from "lucide-react";

const ICONS = [Ship, Waves, Wine, UtensilsCrossed, PartyPopper, Clock, Music];

export const Schedule = () => {
  return (
    <section
      className="px-6 py-16 md:px-16 md:py-24"
      data-testid="schedule-section"
    >
      <div className="mx-auto max-w-6xl">
        <p className="mb-4 text-xs uppercase tracking-[0.3em] text-[#7A6A5E]">The Weekend</p>
        <h2 className="font-display text-3xl font-light tracking-tight text-[#3F3A32] md:text-5xl">
          How we'll spend the weekend
        </h2>

        <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-2">
          {EVENT.schedule.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={`${item.time}-${item.title}`}
                className={`flex flex-col justify-between border border-[#DCD3C0] bg-[#FAF7F0] p-8 transition-colors hover:border-[#C4B99F] ${item.images ? "md:col-span-2" : ""}`}
                data-testid={`schedule-item-${i}`}
              >
                <Icon className="h-6 w-6 text-[#7A6A5E]" strokeWidth={1.5} />
                <div className="mt-10">
                  <p className="text-xs uppercase tracking-[0.2em] text-[#7A7264]">{item.time}</p>
                  <div className="mt-2 font-display text-2xl font-light tracking-tight text-[#3F3A32] md:text-3xl">
                    {item.title}
                  </div>
                  {item.sub && (
                    <p className="mt-2 text-xs uppercase tracking-[0.2em] text-[#7A6A5E]">
                      {item.sub}
                    </p>
                  )}
                  {item.desc && (
                    <p className="mt-3 text-base font-light leading-relaxed text-[#5E574B]">
                      {item.desc}
                    </p>
                  )}
                  {item.linkUrl && (
                    <a
                      href={item.linkUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`schedule-item-${i}-link`}
                      className="mt-4 inline-block text-sm font-light uppercase tracking-[0.15em] text-[#7A6A5E] underline decoration-[#C9BFA9] underline-offset-4 transition-colors hover:text-[#3F3A32]"
                    >
                      {item.linkText}
                    </a>
                  )}
                  {item.images && (
                    <div className="mt-8">
                      {item.images.map((src) => (
                        <img
                          key={src}
                          src={src}
                          alt={item.title}
                          data-testid={`schedule-item-${i}-image`}
                          className="w-full"
                        />
                      ))}
                    </div>
                  )}
                  {item.extraText && (
                    <p className="mt-6 text-base font-light leading-relaxed text-[#5E574B]" data-testid={`schedule-item-${i}-extra`}>
                      {item.extraText}{" "}
                      <a
                        href={`mailto:${item.extraEmail}`}
                        data-testid={`schedule-item-${i}-extra-link`}
                        className="text-[#7A6A5E] underline decoration-[#C9BFA9] underline-offset-4 transition-colors hover:text-[#3F3A32]"
                      >
                        {item.extraEmail}
                      </a>
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
